/* Local, progressive enhancement. No network calls, cookies or stored search history. */
(() => {
  'use strict';
  document.querySelectorAll('[data-ef-topic-search]').forEach(root => {
    const input = root.querySelector('input[type="search"]');
    if (!input) return;
    const items = [...root.querySelectorAll('[data-search-item]')];
    const filters = [...root.querySelectorAll('[data-topic-filter]')];
    const count = root.querySelector('[data-search-count]');
    const empty = root.querySelector('[data-search-empty]');
    let category = 'all';
    const normalize = s => s.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    const searchable = new Map(items.map(el => [el, normalize(el.textContent + ' ' + (el.dataset.searchTerms || ''))]));
    const apply = () => {
      const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      let visible = 0;
      items.forEach(item => {
        const match = (category === 'all' || item.dataset.category === category) && words.every(word => searchable.get(item).includes(word));
        item.hidden = !match;
        if (match) visible++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topicFilter === category)));
      if (count) count.textContent = visible + ' of ' + items.length + (root.classList.contains('ef-support-faq') ? ' questions' : ' topics');
      if (empty) empty.hidden = visible !== 0;
    };
    input.addEventListener('input', () => { category = 'all'; apply(); });
    filters.forEach(button => button.addEventListener('click', () => { category = button.dataset.topicFilter; apply(); }));
    root.querySelector('[data-search-clear]')?.addEventListener('click', () => { input.value = ''; category = 'all'; apply(); input.focus(); });
    root.querySelectorAll('[data-search-controls]').forEach(el => { el.hidden = false; });
    apply();
  });
  const policy = document.querySelector('.shopify-policy__body');
  if (!policy || !document.querySelector('.ef-support-nav')) return;
  // Repair non-functional contact links in old rich text without changing policy wording.
  policy.querySelectorAll('a:not([href])').forEach(link => {
    const email = link.textContent.trim();
    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) link.href = 'mailto:' + email;
  });
  policy.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.getAttribute('href'), location.origin);
    if (url.origin === location.origin && url.pathname.toLowerCase() === '/apps/17track') link.href = '/pages/track-order';
  });
  const headings = [...policy.querySelectorAll('h2,h3')].filter(el => el.textContent.trim() && !el.classList.contains('efx-policy__body-title') && getComputedStyle(el).display !== 'none');
  if (headings.length >= 3) {
    const details = document.createElement('details');
    details.className = 'ef-support-policy-index';
    const summary = document.createElement('summary');
    summary.textContent = 'On this page';
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Policy sections');
    headings.forEach((heading, i) => {
      if (!heading.id) {
        let id = 'ef-policy-section-' + (i + 1);
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      nav.append(link);
    });
    details.append(summary, nav);
    policy.before(details);
  }
  const aside = document.createElement('aside');
  aside.className = 'ef-support-policy-help';
  const p = document.createElement('p');
  p.textContent = 'Have a question about your order? Include your order number when you contact us.';
  const a = document.createElement('a');
  a.href = '/pages/contact-us';
  a.textContent = 'Contact our team →';
  aside.append(p, a);
  policy.after(aside);
})();
